import React from 'react';
import { Modal, Table, Typography, Row, Col, Card } from 'antd';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import moment from 'moment';

const { Title, Text } = Typography;

const TrendModal = ({ visible, onCancel, parameterData }) => {
  if (!parameterData) {
    return null;
  }

  const { parameterName, units, trendData } = parameterData;

  const sortedTrendData = trendData.sort((a, b) => moment(a.date).unix() - moment(b.unix()));

  const columns = [
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: (text) => moment(text).format('YYYY-MM-DD HH:mm'),
    },
    {
      title: `Value (${units})`,
      dataIndex: 'value',
      key: 'value',
    },
  ];

  const calculateStats = () => {
    if (sortedTrendData.length <= 1) {
      return null;
    }

    const values = sortedTrendData.map(d => d.value);
    const mean = values.reduce((a, b) => a + b, 0) / values.length;
    const firstValue = values[0];
    const lastValue = values[values.length - 1];
    const percentChange = ((lastValue - firstValue) / firstValue) * 100;

    return {
      mean: mean.toFixed(2),
      percentChange: percentChange.toFixed(2),
    };
  };

  const stats = calculateStats();

  return (
    <Modal
      title={<Title level={4}>Trend for {parameterName}</Title>}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={800}
    >
      {sortedTrendData.length > 1 && (
        <Row gutter={16} style={{ marginBottom: 24 }}>
          <Col span={12}>
            <ResponsiveContainer width="100%" height={300}>
              <LineChart data={sortedTrendData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" tickFormatter={(tick) => moment(tick).format('MM/DD')} />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey="value" stroke="#8884d8" name={parameterName} />
              </LineChart>
            </ResponsiveContainer>
          </Col>
          <Col span={12}>
            <Card>
              <Title level={5}>Statistics</Title>
              {stats && (
                <>
                  <p><Text strong>Average/Mean:</Text> {stats.mean} {units}</p>
                  <p><Text strong>Percent Change:</Text> {stats.percentChange}%</p>
                </>
              )}
            </Card>
          </Col>
        </Row>
      )}
      <Table
        columns={columns}
        dataSource={sortedTrendData}
        pagination={false}
        rowKey="date"
        size="small"
      />
    </Modal>
  );
};

export default TrendModal;
